// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import styled from 'styled-components';
import Icon from '../../../components/Icon';
import LanguageIconSrc from '../../../assets/images/language.svg';
import LanguageActiveIcon from '../../../assets/images/language_selected.svg';

interface LanguageIconProps extends React.ComponentPropsWithRef<'div'> {
  active?: boolean;
}

const S = {
  Container: styled.div`
    display: flex;
    position: relative;
    height: 32px;
  `,
  LanguageIcon: styled(Icon).attrs({ icon: LanguageIconSrc })<{ show?: boolean }>`
    ${props => !props.show ? { display: 'none' } : null }
  `,
  LanguageActiveIcon: styled(Icon).attrs({ icon: LanguageActiveIcon })<{ show?: boolean }>`
    ${props => !props.show ? { display: 'none' } : null }
  `,
}

const LanguageIcon: React.FC<LanguageIconProps> = ({ active, ...props }) => {
  return (
    <S.Container {...props}>
      <S.LanguageIcon show={!active} />
      <S.LanguageActiveIcon show={active}/>
    </S.Container>
  )
}

export { LanguageIcon as default }
